<template>
  <div class="annexUpload">
    <el-upload
      :action="url"
      :show-file-list="false"
      :before-upload="beforeAvatarUpload"
      :multiple="false"
      :http-request="upload"
      :accept="accept"
      :data="data"
    >
      <slot name="uploadContent"></slot>
    </el-upload>
  </div>
</template>

<script>
import Util from "@lib/util.js";
import BaseApi from "@lib/baseApi.js";
import axios from "axios";
export default {
  data() {
    return {
      data: {
        fileType: "1",
        // fileName: "22222"
      },
      isLoading: false
    };
  },
  props: ["url", "size", "format", "fileList", "accept"],
  mounted() {
   
  },

  methods: {
    upload(fileObj) {
      let file = fileObj.file;
      console.log(file);
      this.fileList.forEach((val, index) => {
        if (val.fileName + "." + val.fileFormat == file.name) {
          file = new File(
            [file],
            `${val.fileName}(${val.currentIndex}).${val.fileFormat}`
          );
          this.$emit("changCurrentIndex", {
            index: index,
            value: val.currentIndex - 0 + 1
          });
        }
      });
      var formData = new FormData();
      formData.append("file", file);
      formData.append("fileType", 1);
      axios({
        method: "post",
        url: this.url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.token || "mVYUzIuJCAmoOjgiI0xaaW8mfqJGPq",
          "X-CSRF-Token": sessionStorage.token,
          "request-id": Util.getUID()
        }
      }).then(this.handleAvatarSuccess, this.handleError);
    },
    handleAvatarSuccess(res, file) {
      this.$emit("loadingEnd");
      if (res.code == 200) {
        this.$emit("uploadSuccess", res);
      } else {
        if (res.code == 102 || res.code == 103) {
          window.location.href = "/verification/login";
        } else {
          this.$message.error(res.message || "上传失败");
        }
      }
    },
    handleError() {
      this.$emit("loadingEnd");
      this.$message.error("上传失败");
    },
    beforeAvatarUpload(file) {
      if (this.accept) {
        let acceptList = this.accept.split(',');
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf("."));
        }
        const isTypeOk = acceptList.some((type) => {
          // if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(
            `文件格式不正确, 请上传${acceptList.join("/")}格式文件!`
          );
          return false;
        }
      }
      const isLt30M = file.size / 1024 / 1024 < (this.size || 5);
      if (!isLt30M) {
        this.$message.error(`上传的附件不能超过${this.size}M!`);
      } else {
        this.$emit("loadingStart");
      }
      return isLt30M;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.annexUpload {
  .el-upload {
    display: block;
  }
}
</style>
